import axios from "axios";
import { createProformaDTO, GetAllIVReimbursementDTO, GetAllIVReimbursementFiltersDTO, GetAllProformaFiltersDTO, GetAllProformaResponseDTO, IVReimbursementAssignmentEstimatedCostDTO, IVReimbursementDTO, ReimbursementTypeEnum, UpdateProformaDTO } from "./dto";
import { IVReimbursementService } from "./service";
import { keycloak } from "../../../../../../lib/keycloak";

export class IVReimbursementServiceImpl implements IVReimbursementService {

    public CreateIVReimbursement(data: IVReimbursementDTO): Promise<void> {
        return axios.post("/api/inspcetion-visit-reimbursement",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public UpdateIVReimbursement(data: IVReimbursementDTO, id: string): Promise<void> {
        return axios.put("/api/inspcetion-visit-reimbursement/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteIVReimbursement(id: string): Promise<void> {
        return axios.delete("/api/inspcetion-visit-reimbursement/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetIVReimbursementAssignmentCostEstimates(assignmentId: string): Promise<IVReimbursementAssignmentEstimatedCostDTO> {
        return axios.get("/api/inspcetion-visit-reimbursement/assignment-cost-estimates/" + assignmentId, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetIVReimbursementByInspectorCodeAndType(inspectorCode: string, type: ReimbursementTypeEnum): Promise<IVReimbursementDTO> {
        return axios.get("/api/inspcetion-visit-reimbursement/get-by-inspector-code-and-type", {
            params: {
                inspectorCode: inspectorCode,
                reimbursementType: type
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetAllIVReimbursement(filters: GetAllIVReimbursementFiltersDTO): Promise<GetAllIVReimbursementDTO> {
        return axios.get("/api/inspcetion-visit-reimbursement", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                inspectionVisitId: filters.inspectionVisitId,
                assignmentId: filters.assignmentId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetAllProforma(filters: GetAllProformaFiltersDTO): Promise<GetAllProformaResponseDTO> {
        return axios.get("/api/proforma", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                year: filters.year,
                assignmentId: filters.assignmentId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public CreateProforma(data: createProformaDTO): Promise<void> {
        return axios.post("/api/proforma",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetIVReimbursementById(id: string): Promise<IVReimbursementDTO> {
        return axios.get("/api/inspcetion-visit-reimbursement/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public UpdateProforma(data: UpdateProformaDTO, id: string): Promise<void> {
        return axios.put("/api/proforma/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }
}